import React, { useState, useEffect } from "react";

import { Toaster, ListBoxModal } from "components";

import { func_validation, isCompletelyEqual } from "functions";


export function useUserGroup(props) {
    const {
        userGroupList,
        selectedUserGroupIndexList,
        selectedUserDetail,
        totalRequests,

        getUserGroupList_requesting,
        addUserGroupMapping_requesting,
        removeUserGroupMapping_requesting,
        isUserRecordUpdatedSuccessfully
    } = props;

    const [isRemovingUserGroup_requesting, setIsRemovingUserGroup_requesting] = useState();
    const [isModalVisible_userGroup, setIsModalVisible_userGroup] = useState(false);

    function handleUserGroupUpdate(selectedValues) {
        // Username is required
        if (func_validation.isObjectEmpty(selectedUserDetail)) return;
        let userName = func_validation.getObjectPropertyValue(selectedUserDetail, "UserName");

        // convert to object for faster traversing
        let selectedValueObj = {}
        if (func_validation.isArrayNotEmpty(selectedValues)) {
            selectedValues.map((userGroupDetails, idx) => {
                let id = func_validation.getObjectPropertyValue(userGroupDetails, "ID");
                selectedValueObj[id] = true;
            })
        }
        let selectedUserGroupListObj = {}
        if (func_validation.isArrayNotEmpty(selectedUserGroupIndexList) &&
            func_validation.isArrayNotEmpty(userGroupList)) {
            selectedUserGroupIndexList.map((userGroupIndex, idx) => {
                let obj = userGroupList[userGroupIndex];
                let id = func_validation.getObjectPropertyValue(obj, "ID");
                selectedUserGroupListObj[id] = true;
            })
        }


        // Deletion
        let deletedList = [];
        if (func_validation.isArrayNotEmpty(selectedUserGroupIndexList)) {
            selectedUserGroupIndexList.map((userGroupIndex) => {
                let obj = userGroupList[userGroupIndex];
                let id = func_validation.getObjectPropertyValue(obj, "ID");

                if (!selectedValueObj.hasOwnProperty(id)) {

                    // Find the user group mapping id for the selected user group id
                    let userGroupMappings = func_validation.getObjectPropertyValue(selectedUserDetail, "UserGroupMappings");
                    if (func_validation.isArrayNotEmpty(userGroupMappings)) {
                        for (let i = 0; i < userGroupMappings.length; i++) {
                            let userGroupMapping = userGroupMappings[i];
                            let userGroupId = func_validation.getObjectPropertyValue(userGroupMapping, "UserGroupId");

                            if (userGroupId == id) {
                                let mappingId = func_validation.getObjectPropertyValue(userGroupMapping, "ID");

                                deletedList.push(mappingId);
                                break;
                            }
                        }
                    }
                }
            });

            if (props.removeUserGroupMapping &&
                func_validation.isArrayNotEmpty(deletedList)) {

                if (func_validation.isUserAccessGranted(props, "Internal_UserGroupMapping_Delete")) {
                    deletedList.map((id) => {
                        props.removeUserGroupMapping(id);
                    })
                }
                else {
                    Toaster({ 
                        type: "error",
                        msg: "No permission granted to delete user group mapping"
                    });
                }
            }
        }

        // Addition
        let addedList = [];
        if (func_validation.isArrayNotEmpty(selectedValues)) {
            selectedValues.map((userGroupDetails) => {
                let id = func_validation.getObjectPropertyValue(userGroupDetails, "ID");

                if (!selectedUserGroupListObj.hasOwnProperty(id) &&
                    func_validation.isStringTrimNotEmpty(userName)) {
                    let obj = {};
                    obj["ID"] = 0;
                    obj["UserName"] = userName;
                    obj["UserGroupId"] = id;

                    addedList.push(obj);
                }
            });

            if (props.addUserGroupMapping &&
                func_validation.isArrayNotEmpty(addedList)) {

                if (func_validation.isUserAccessGranted(props, "Internal_UserGroupMapping_Add")) {
                    props.addUserGroupMapping(addedList);
                }
                else {
                    Toaster({
                        type: "error",
                        msg: "No permission granted to add user group mapping"
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (props.getUserGroupList)
            props.getUserGroupList();
    }, []);

    useEffect(() => {
        if (totalRequests <= 0)
            setIsRemovingUserGroup_requesting(false);
    }, [totalRequests]);

    let userGroupLabels = [];
    if (func_validation.isArrayNotEmpty(userGroupList)) {
        userGroupList.map((userGroupObj, idx) => {
            let groupName = func_validation.getObjectPropertyValue(userGroupObj, "GroupName");
            userGroupLabels.push(groupName);
        })
    }

    let modalDisplay = (
        <ListBoxModal
            isModalVisible={isModalVisible_userGroup}
            updateParentState={setIsModalVisible_userGroup}

            title={"User Group"}

            header={"List"}

            initSelectedIndexes={selectedUserGroupIndexList}
            list={userGroupList}
            labelList={userGroupLabels}
            isListLoading={getUserGroupList_requesting}

            actionTxt={"Save"}
            handleOnConfirm={(list) => { 
                handleUserGroupUpdate(list); 
                setIsRemovingUserGroup_requesting(true); 
            }}
            isActionLoading={addUserGroupMapping_requesting || removeUserGroupMapping_requesting}
            isClosedOnSuccess={isUserRecordUpdatedSuccessfully}

            isDisabled={func_validation.isUserAccessDenied(props, "Internal_UserGroupMapping_Add") &&
                func_validation.isUserAccessDenied(props, "Internal_UserGroupMapping_Delete")}
        />
    )

    return {
        modalDisplay,
        userGroupLabels,
        setIsModalVisible_userGroup
    }
}